import React, { Component } from "react";
import "./DegreeCard.css";
import { Fade, Flip } from "react-reveal";
import { withTranslation } from 'react-i18next';

class DegreeCard extends Component {
  render() {
    const degreeKey = this.props.degreeKey;
    const degree = this.props.degree; // Keep for logo_path and website_link
    const theme = this.props.theme;
    const { t } = this.props;
    return (
      <div className="degree-card">
        {degree.logo_path && (
          <Flip left duration={2000}>
            <div className="card-img">
              <img
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectPosition: "center", // centers it in the container
                  objectFit: "contain",   // preserves aspect ratio
                  transform: "scale(0.8)",
                  marginTop: "20px"
                }}
                src={require(`../../assets/images/${degree.logo_path}`)}
                alt={t(`portfolio.degrees.${degreeKey}.altName`)}
              />
            </div>
          </Flip>
        )}
        <Fade right duration={2000} distance="40px">
          <div
            className="card-body"
            style={{ width: degree.logo_path ? "90%" : "100%" }}
          >
            <div
              className="body-header"
              style={{ backgroundColor: theme.headerColor }}
            >
              <div className="body-header-title">
                <h2 className="card-title" style={{ color: theme.text }}>
                  {t(`portfolio.degrees.${degreeKey}.title`)}
                </h2>
                <h3 className="card-subtitle" style={{ color: theme.text }}>
                  {t(`portfolio.degrees.${degreeKey}.subtitle`)}
                </h3>
              </div>
              <div className="body-header-duration">
                <h3 className="duration" style={{ color: theme.text }}>
                  {t(`portfolio.degrees.${degreeKey}.duration`)}
                </h3>
              </div>
            </div>
            <div className="body-content">
              {t(`portfolio.degrees.${degreeKey}.descriptions`, { returnObjects: true }).map((sentence, idx) => (
                <p
                  key={idx}
                  className="content-list"
                  style={{ color: theme.text }}
                  dangerouslySetInnerHTML={{ __html: sentence }}
                />
              ))}
              {degree.website_link && (
                <a
                  href={degree.website_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div
                    className="visit-btn"
                    style={{ backgroundColor: theme.headerColor }}
                  >
                    <p className="btn" style={{ color: theme.text }}>
                      {t('buttons.visitWebsite')}
                    </p>
                  </div>
                </a>
              )}
            </div>
          </div>
        </Fade>
      </div>
    );
  }
}

export default withTranslation()(DegreeCard);
